import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PublicService } from 'src/app/services/public/public.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
  selector: 'app-printapplication',
  templateUrl: './printapplication.component.html',
  styleUrls: ['./printapplication.component.css']
})

export class PrintapplicationComponent implements OnInit {
  H: any;
  SearchModel = {
    StudentID: '0',


  }
  DocumentList = [];
  ApplicationStatus: any;
  PrintType: '';
  constructor(private activatedRoute: ActivatedRoute, private publicService: PublicService,
    private spinnerService: Ng4LoadingSpinnerService, public globalHelper: GlobalHelper) {
    this.activatedRoute.queryParams.subscribe(params => {
      this.SearchModel.StudentID = params['StudentID'];
      this.GetApplicationPrint();

    });
  }


  GetApplicationPrint() {

    this.spinnerService.show();
    this.publicService.GetApplicationPrint(this.SearchModel.StudentID).subscribe((response) => {
      if (response.ApplicationStatus != null) {
        this.ApplicationStatus = response.ApplicationStatus[0];
        this.GetApplicationDocument()
      }
    })

  }

  GetApplicationDocument() {   
    this.publicService.GetApplicationDocument(this.SearchModel.StudentID).subscribe((response) => {
      this.spinnerService.hide();
      this.DocumentList = response.ApplicationDocument;

    })
  }
  ngOnInit() {
  }

}